<template>
  <div class="form__input" ref="selectRef">
    <label class="label label--muted label--semibold" :class="{ 'label--required': required }">
      {{ label }}
    </label>
    <div class="select" :class="{ 'select--selected': isOpenDropdown, 'select--errors': allErrors?.length, 'select--filled': selectedOption.text }">
      <button class="select__field" type="button" @mousedown.prevent="onToggleDropdown">
        <button type="button" v-if="selectedOption.text" @mousedown.stop @click="onSelectOption({})">
          <img class="select__icon icon icon--dark icon--sm" src="~images/close.svg" v-svg-inline/>
        </button>

        <input
          :value="selectedOption.text"
          :placeholder="placeholder"
          @focus="$event.currentTarget.blur()"
          class="select__search-field"
        >
      </button>

      <t-dropdown
        v-model="isOpenDropdown"
        :parent="selectRef"
        :items="options"
        :selectedItem="selectedOption"
        @select="onSelectOption"
      />
    </div>
    <t-errors :errors="allErrors" />
  </div>
</template>

<script setup>
import { TDropdown, TErrors } from '@shared/ui'
import { useFieldErrors } from '@shared/lib'
import { ref, watch, computed } from 'vue'

const props = defineProps({
  options: Array,
  placeholder: { type: String, default: "Выберите из списка" },
  label: String,
  required: Boolean,
  errors: Array,
  name: String,
})

const { fieldErrors, clearFieldErrors } = useFieldErrors(props.name)
const allErrors = computed(() => props.errors ?? fieldErrors.value)

const model = defineModel({ default: null })

const selectRef = ref(null)
const selectedOption = ref({ value: '', text: '' })
const isOpenDropdown = ref(false)

const onSelectOption = (option) => {
  if (fieldErrors.value.length) clearFieldErrors()
  if (!option?.value || selectedOption.value?.value === option.value) {
    selectedOption.value = { value: '', text: '' }
    model.value = null
    return
  }
  selectedOption.value = JSON.parse(JSON.stringify(option))
  model.value = option.value
}

const onToggleDropdown = () => { isOpenDropdown.value = !isOpenDropdown.value }

watch([model, () => props.options], ([newValue]) => {
  if (!newValue) {
    selectedOption.value = { value: '', text: '' }
    return
  }
  const found = props.options.find(el => el.value == newValue) || {}
  selectedOption.value = { ...found }
}, { immediate: true })
</script>
